import { Button } from '@shared/components/ui/button';
import { Search } from '@shared/components/ui/Search/Search';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpArrowDown, faCheck } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

interface OrdersHeaderProps {
  shouldShowRegisteredData: boolean;
  registeredCount: number;
  processedCount: number;
  ordersSearch: string;
  setOrdersSearch: (value: string) => void;
  ordersSortBy: string;
  handleOrdersSort: (sortBy: string) => void;
}

export const OrdersHeader = ({
  shouldShowRegisteredData,
  registeredCount,
  processedCount,
  ordersSearch,
  setOrdersSearch,
  ordersSortBy,
  handleOrdersSort,
}: OrdersHeaderProps) => {
  const { t } = useTranslation('receiveModule');

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <h2 className="text-title text-lg">
          {shouldShowRegisteredData ? t('ui.registered_orders') : t('ui.reused_orders')}
        </h2>
        <span className="inline-flex items-center justify-center rounded-full px-2 bg-bg-info text-info">
          {shouldShowRegisteredData ? registeredCount : processedCount}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Search
          dataTestId="orders-search"
          placeholder={t('orders.search_placeholder')}
          value={ordersSearch}
          onChange={(e) => setOrdersSearch(e.currentTarget.value)}
        />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="icon" className="h-8" data-testid="orders-sort-button">
              <FontAwesomeIcon icon={faArrowUpArrowDown} className="w-3.5 h-3.5 text-icons" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[200px]">
            <DropdownMenuItem
              data-testid="orders-sort-more-qty"
              onClick={() => handleOrdersSort('more_qty')}
              className={ordersSortBy === 'more_qty' ? 'bg-card-border' : ''}
            >
              {t('ui.sort.more_qty')}
              {ordersSortBy === 'more_qty' && <FontAwesomeIcon icon={faCheck} className="w-3 h-3 ml-auto" />}
            </DropdownMenuItem>
            <DropdownMenuItem
              data-testid="orders-sort-less-qty"
              onClick={() => handleOrdersSort('less_qty')}
              className={ordersSortBy === 'less_qty' ? 'bg-card-border' : ''}
            >
              {t('ui.sort.less_qty')}
              {ordersSortBy === 'less_qty' && <FontAwesomeIcon icon={faCheck} className="w-3 h-3 ml-auto" />}
            </DropdownMenuItem>
            <DropdownMenuItem
              data-testid="orders-sort-name-az"
              onClick={() => handleOrdersSort('name_az')}
              className={ordersSortBy === 'name_az' ? 'bg-card-border' : ''}
            >
              {t('ui.sort.name_az')}
              {ordersSortBy === 'name_az' && <FontAwesomeIcon icon={faCheck} className="w-3 h-3 ml-auto" />}
            </DropdownMenuItem>
            <DropdownMenuItem
              data-testid="orders-sort-name-za"
              onClick={() => handleOrdersSort('name_za')}
              className={ordersSortBy === 'name_za' ? 'bg-card-border' : ''}
            >
              {t('ui.sort.name_za')}
              {ordersSortBy === 'name_za' && <FontAwesomeIcon icon={faCheck} className="w-3 h-3 ml-auto" />}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
